<template>
    <section class="tips-tricks" id="blog">
        <div class="container container--mw-xxl">
            <template v-if="!loading && Object.keys(data).length > 0">
                <h2 class="tips-tricks__heading">Tips & Tricks</h2>
                <div class="row justify-content-center justify-content-lg-between">
                    <div class="col-12 col-md-10 col-lg-4 col-xl-auto tips-tricks__column" v-for="item in data"
                        :key="item.id">
                        <TipsTricksBlock :heading="item.title" :short-description="item.featured_text"
                            @open-modal="toggleModal(item)" :image="item.banner" />
                    </div>
                </div>
                <div class="tips-tricks__cta" style="text-align:center">
                        <a :href="blogURL + '/blog/' + this.slug" class="cta" target="_blank">
                            <span>View more</span>
                            <svg width="13px" height="10px" viewBox="0 0 13 10">
                                <path d="M1,5 L11,5"></path>
                                <polyline points="8 1 12 5 8 9"></polyline>
                            </svg>
                        </a>
                    </div>
            </template>
            <transition name="fade">
                <tips-tricks-modal v-if="showModal" :heading="this.title" @close-modal="toggleModal">
                    <div v-html="this.content"></div>
                    <div class="tips-tricks__cta">
                        <a :href="blogURL + '/blog/post/' + this.slug" class="cta" target="_blank">
                            <span>View more</span>
                            <svg width="13px" height="10px" viewBox="0 0 13 10">
                                <path d="M1,5 L11,5"></path>
                                <polyline points="8 1 12 5 8 9"></polyline>
                            </svg>
                        </a>
                    </div>
                </tips-tricks-modal>
            </transition>
            <template v-if="loading && data.length == 0">
                <div class="tips-tricks__loader">
                    <span class="loader"></span>
                </div>
            </template>
            
            <template v-if="!loading && data.length == 0">

            </template>
        </div>
    </section>
</template>

<script>
import TipsTricksBlock from "@/views/HomePage/TipsTricksBlock";
import TipsTricksModal from "@/views/HomePage/TipsTricksModal";
import axios from "axios";

export default {
    name: 'TipsTricks',
    components: {
        TipsTricksModal,
        TipsTricksBlock,
    },
    data() {
        return {
            showModal: false,
            data: [],
            blogURL: process.env.VUE_APP_BLOG_URL,
            loading: true,
            title: '',
            content: '',
            slug: ''
        }
    },
    async mounted() {
        try {
            let response = await axios.get(this.blogURL + '/api/latest-blogs')
            this.data = response.data
            console.log(this.data.length)
            this.loading = false
        } catch (e) {
            this.loading = false
        }

    },
    methods: {
        toggleModal(data = false) {
            if (data) {
                this.title = data.title
                this.content = data.content
                this.slug = data.slug
            }

            this.showModal = !this.showModal;
            this.stopScrollOnBody();
        },
        stopScrollOnBody() {
            if (this.showModal) {
                document.body.style.overflow = "hidden";
            } else {
                document.body.style.overflow = "";
            }
        },
        parseHtml(html) {
            const parser = new DOMParser();
            const elem = parser.parseFromString(html, 'text/html');

            return elem.body.innerText;
        }
    }
}
</script>